import React from 'react';
import times from 'lodash/times';
import { Box } from '../../CommonComponents/OPL/Box/Box';
import { Card } from '../../CommonComponents/OPL/Card/Card';
import { Shimmer } from '../../CommonComponents/OPL/Shimmer/Shimmer';
import { PieChartLoading } from '../../CommonComponents/OPL/charts/PieChart/PieChart.loading';
import { Content, StickyFooter } from '../../CommonComponents/OPL/StickyFooter/StickyFooter';

export const AutoAccountWorkflowResultFetchingTabs = () => (
  <Box width="550px" m="auto">
    <Shimmer width={500} height={23} mb="32" mx="auto" />
    <Shimmer width="100%" height={30} />
  </Box>
);

export const AutoAccountWorkflowResultFetchingCard = () => (
  <Card mt="32" p="32" width="550px">
    <Shimmer width={250} height={20} mb="16" />

    <Box border="1px solid" borderColor="neutral.200" borderRadius="medium" display="flex" mb="24">
      <Box
        display="flex"
        flexDirection="column"
        borderRight="1px solid"
        borderColor="neutral.200"
        flex={1}
        p="24"
      >
        <Shimmer width={150} height={15} mb="8" />
        <Shimmer width={200} height={47} />
      </Box>
      <Box display="flex" flexDirection="column" p="24" alignItems="center">
        <Shimmer width={80} height={15} mb="8" />
        <Shimmer width={80} height={47} />
      </Box>
    </Box>

    <Box display="flex" justifyContent="center">
      <Shimmer width={150} height={30} />
    </Box>

    <Box display="flex" mt="32">
      <Box display="flex" flex={1} alignItems="center" justifyContent="center">
        <Box height={250} width={250}>
          <PieChartLoading hasTitle={false} innerSize="75%" />
        </Box>
      </Box>

      <Box
        as="ol"
        alignItems="center"
        css="list-style-type: none"
        display="flex"
        justifyContent="center"
        flex={1}
        flexDirection="column"
        pl="40"
      >
        {times(3).map(i => (
          <Box
            as="li"
            alignItems="center"
            display="flex"
            justifyContent="space-between"
            width="100%"
            mb="16"
            key={i}
          >
            <Box display="flex" alignItems="center">
              <Shimmer width={12} height={12} mr="12" />
              <Shimmer width={40} height={20} />
            </Box>
            <Shimmer width={20} height={20} />
          </Box>
        ))}
      </Box>
    </Box>
  </Card>
);

export const AutoAccountWorkflowResultLoading = () => {
  return (
    <Box minWidth={864}>
      <Content>
        <Box display="flex" justifyContent="center" mt={96}>
          <Box>
            <AutoAccountWorkflowResultFetchingTabs />
            <AutoAccountWorkflowResultFetchingCard />
          </Box>
        </Box>
      </Content>

      <StickyFooter />
    </Box>
  );
};
